const getSubCollectionData = require('../services/getSubCollectionData.service')

const getDocs = async (workflowRef) => {
  return await getSubCollectionData(workflowRef, 'docs', {})
}

module.exports = getDocs